@import "../../globalStyles/commons";

:host {
  display: inline-block;
  line-height: 0;
}

.icon {
  display: block;
  line-height: 0;

  /**
    * @prop --goat-icon-size - The size of the icon (height and width)
    */
  height: var(--goat-icon-size, 1rem);
  width: var(--goat-icon-size, 1rem);

  svg {
    fill: currentColor;
    height: 100%;
    width: 100%;
  }
}
